export async function readApiResponse(response:Response) {
  if (!response.headers.get('content-type')?.includes('application/json')) {
    throw new Error(response.status === 403
      ? 'Your connection has expired. Reload the page and try again.'
      : 'The game server is temporarily unavailable. Please try again shortly.');
  }
  let result;
  try { result = await response.json(); }
  catch { throw new Error('The game server sent an incomplete response. Please try again.'); }
  if (!response.ok) throw new Error(typeof result?.error === 'string' ? result.error : 'The request failed. Please try again.');
  return result;
}
